import NotificationPreferences from './NotificationPreferences';

export default NotificationPreferences;
